import { TFunction } from 'i18next';

export const promoConditionTitle = (t: TFunction) => [
  {
    promoType: '1',
    qty: t('min_purchase_quantity'),
    discount: t('Price'),
    ending: t('per_piece'),
    multiple: true,
  },
  {
    promoType: '2',
    // qty: t('purchase_in_full'),
    qty: t('min_req'),
    discount: t('get_a_discount'),
    ending: t(''),
    multiple: false,
  },
  {
    promoType: '3',
    // qty: t('purchase_in_full_pieces'),
    qty: t('min_req_pieces'),
    discount: t('Price'),
    ending: t(''),
    multiple: false,
  },
  // {
  //   promoType : '4',
  //   qty: t(''),
  //   discount: t(''),
  //   ending: t(''),
  //   multiple: 1
  // },
];
